import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { variables } from '../variables';

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    borderBottomColor: variables.borderBottomColor,
    color: variables.headerColor,
    borderBottomWidth: 1,
    alignItems: 'center',
    height: 35,
    textAlign: 'center',
    flexGrow: 1,
  },
});

const PdfTableHeader = ({ data, customStyle }) => {
  const headers = Object.keys(data[0]).map((key) => key);
  return (
    <View style={[styles.container, customStyle['header']['container']]}>
      {headers.map((label, idx) => (
        <Text key={idx} style={[styles[label], customStyle['header'][label]]}>
          {label}
        </Text>
      ))}
    </View>
  );
};

export default PdfTableHeader;
